import getConfig from 'next/config';
import type { NextRuntimeConfiguration } from '@hub/libs/config';

const { publicRuntimeConfig } = getConfig() as NextRuntimeConfiguration;
export const IBD = { ...publicRuntimeConfig.ibd, bearingHubApiVersion: publicRuntimeConfig.bearingHubApiVersion };
export const SURVICATE_WORKSPACE = publicRuntimeConfig.survicateWorkspaceKey;
